const config = {
  defaultPath: "/login",
  fontFamily: `'Poppins', sans-serif`,
  borderRadius: 4,
  domainName:"https://www.aiwritemate.com"
};

export default config;
